// extracted by mini-css-extract-plugin
export default {"olvidoContraseniaContainer":"OlvidoContrasenia_olvidoContraseniaContainer__uwSKV"};